import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../routes";

// Add your logo path
// import BrandLogo from "../../assets/img/brand/brandlogo.jpg";
import BrandLogo from "../../assets/img/brand/Brand_Logo.png";

const REFERRAL_VALIDATE_API_URL = "/api/auth/referral/validate";

const ACTIVE_BUTTON_STYLE = {
  background: "#1D4E89",
  border: "none",
  borderRadius: "0.5rem",
  color: "#ffffff",
};

export default function ReferralValidate() {
  const navigate = useNavigate();
  const [referralNumber, setReferralNumber] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const getPasswordLoginPath = () => {
    return Routes?.SignIn?.path || "/sign-in";
  };

  const validateReferral = async (e) => {
    e.preventDefault();

    const trimmed = referralNumber.trim();

    if (!trimmed) {
      setError("Referral number is required.");
      return;
    }

    try {
      setSubmitting(true);
      setError("");

      const response = await axios.post(REFERRAL_VALIDATE_API_URL, {
        referralNumber: trimmed,
      });

      const data = response?.data || {};

      if (!data?.active) {
        setError("Referral number is not active or does not exist.");
        return;
      }

      const payload = {
        referralNumber: trimmed,
        referrerName: data?.referrerName || "",
      };

      sessionStorage.setItem("registerPrefill", JSON.stringify(payload));

      navigate("/register", {
        state: payload,
      });
    } catch (err) {
      setError(
        err?.response?.data?.message || "Unable to validate referral number."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-shell">
      <section className="py-5 d-flex align-items-center" style={{ minHeight: "100vh" }}>
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8} xl={6}>
              <Card className="border-0 auth-card">
                <Card.Body className="p-4 p-md-5">
                  <div className="auth-logo-wrap">
                    <img src={BrandLogo} alt="LifeSkill Global" />
                  </div>

                  <div className="text-center mb-4">
                    <h4 className="fw-bold mb-1">Create an Account</h4>
                    {/* <p className="text-muted mb-0">
                      Enter your referral number to get started
                    </p> */}
                  </div>

                  <Form onSubmit={validateReferral}>
                    <Form.Group className="mb-3" controlId="referralNumber">
                      <Form.Label className="fw-semibold">Referral Number</Form.Label>
                      <InputGroup className="flex-nowrap">
                        <InputGroup.Text className="bg-white">
                          <FontAwesomeIcon icon={faIdCard} />
                        </InputGroup.Text>
                        <Form.Control
                          value={referralNumber}
                          onChange={(e) => {
                            setReferralNumber(e.target.value);
                            setError("");
                          }}
                          placeholder="Enter referral number"
                          className="py-2 border-start-0"
                          style={{ boxShadow: "none" }}
                        />
                      </InputGroup>

                      {error ? (
                        <div className="text-danger small mt-2">{error}</div>
                      ) : null}
                    </Form.Group>

                    <div className="d-flex justify-content-center">
                      <Button
                        type="submit"
                        disabled={submitting}
                        className="px-5 py-2 fw-bold"
                        style={{
                          minWidth: "120px",
                          ...ACTIVE_BUTTON_STYLE,
                        }}
                      >
                        {submitting ? "VALIDATING..." : "VALIDATE REFERRAL"}
                      </Button>
                    </div>

                    <div className="text-center mt-4">
                      <span className="text-dark">Already have an account? </span>
                      <Link
                        to={getPasswordLoginPath()}
                        className="fw-bold text-decoration-none"
                        style={{ color: "#1D4E89" }}
                      >
                        Sign In
                      </Link>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
}